<template>
  <section class="containerx" id="import-templates-filters">
    <p>
      Aplica los filtros para ver las plantillas de contactos y productos de una campaña.
      <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer">Click aquí</a>
      para conocer más.
    </p>

    <a-form layout="inline">
      <EntityPicker
        v-if="user?.customer?.type_business == 1"
        v-model:value="selectedEntity"
        default-behavior
        :show-all="false"
        class="form__select"
      />

      <CampaignPicker
        v-model:value="selectedPortfolio"
        default-behavior
        class="form__select"
        :entity="selectedEntity"
        :show-all="false"
        :change="handlePortfolioChange"
        @onSetPortfolios="(event) => (portfolios = event)"
        icon-hubspot
        for-hubspot-template
        onlyWithEntity
      />
    </a-form>

    <div class="containerx__body">
      <TemplateList v-if="selectedPortfolio" />
      <div v-else class="containerx__empty">
        <p class="text__info">Para encontrar resultados selecciona una empresa y una campaña</p>
      </div>
    </div>
  </section>
</template>

<script>
import { defineComponent } from "vue";

import TemplateList from "@/app/imports/components/lists/TemplateList.vue";
import EntityPicker from "@/app/shared/components/pickers/EntityPicker.vue";
import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";
import httpManager from "@/app/shared/utils/httpManager";

export default defineComponent({
  components: {
    TemplateList,
    EntityPicker,
    CampaignPicker,
  },
  data() {
    const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/crm/plantillas-1/`;
    const portfolio = this.$store.getters["getTemplateSelectedPortfolio"];
    return {
      selectedEntity: portfolio?.entity?.id || undefined,
      selectedPortfolio: portfolio?.id || undefined,
      DOCS_URL: DOCS_URL,
      portfolios: [],
    };
  },
  computed: {
    entities() {
      return this.$store.getters["getEntityList"];
    },
    // portfolios() {
    //   console.log("Getting portfolios from store:", this.$store.getters["getFilteredPortfolios"]);
    //   return this.$store.getters["getFilteredPortfolios"];
    // },
    user() {
      return this.$store.getters["getDataUser"];
    },
  },
  created() {
    this.$store.dispatch("fetchAllEntities");
    // this.$store.dispatch("fetchAllPortfoliosByEntity");
  },
  methods: {
    handlePortfolioChange(portfolioId) {
      const portfolio = this.portfolios.find(item => item?.id == portfolioId);
      this.$store.dispatch("setTemplatePortfolio", portfolio);
      this.$store.dispatch("fetchTemplateByPortfolio");
    },
  },
});
</script>

<style lang="sass" scoped>
.containerx
  padding: 12px 20px
  min-width: 600px
  max-width: 50%

  &__body
    display: block
    margin-top: 8px
    border-top: $border-normal

  &__empty
    display: flex
    justify-content: center
    margin: 40px 0

  .form__select
    width: 200px

.text__info
 color: $gray-7
 font-weight: 300
 font-size: 16px
</style>
